import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ResourceTag } from 'libs/shared/model/src/lib/widgets/resource-tag.model';
import { ChipComponent, IconDirective } from 'shared/ui-common';

import { ResourceTagChipComponent } from '../resource-tag-chip/resource-tag-chip.component';

@Component({
  selector: 'tt-resource-tag-list',
  standalone: true,
  templateUrl: './resource-tag-list.component.html',
  styleUrls: ['./resource-tag-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'data-testid': 'tt-resource-tag-list',
  },
  imports: [MatIcon, ChipComponent, IconDirective, ResourceTagChipComponent],
})
export class ResourceTagListComponent {
  public tags = input<ResourceTag[]>([]);
  public readonly = input<boolean>(false);

  public tagRemoved = output<ResourceTag>();

  protected removeTag(event: MouseEvent, tag: ResourceTag): void {
    event.stopPropagation();
    this.tagRemoved.emit(tag);
  }
}
